import React from "react";
import { DefinitionList } from "components/common";
import { defaultCompare } from "logic/DefaultCompare";
const EventFields = ({ fields }) => {
  const fieldNames = Object.keys(fields).sort(defaultCompare);
  return /* @__PURE__ */ React.createElement(DefinitionList, null, fieldNames.map((fieldName) => /* @__PURE__ */ React.createElement(React.Fragment, { key: fieldName }, /* @__PURE__ */ React.createElement("dt", null, fieldName), /* @__PURE__ */ React.createElement("dd", null, fields[fieldName]))));
};
export default EventFields;
